const actionTypes = {
  CHANGE_PAGE: 'searchList/changePage',
  FETCH_PROGRESS: 'searchList/fetchProgress',
  FETCH_SUCCESS: 'searchList/fetchSuccess',
  FETCH_ERROR: 'searchList/fetchError',
  FETCHING_ERROR_CLIENT: 'searchList/fetchErrorClient',
  FETCH_PAGE_START: 'searchList/fetchPageStart',
  FETCH_PAGE_SUCCESS: 'searchList/fetchPageSuccess',
  FETCH_PAGE_ERROR: 'searchList/fetchPageError',
  FILTER_CHANGE: 'searchList/filterChange',
  RESET_FILTERS: 'searchList/resetFilters',
  SET_ACTIVE_FILTERS: 'searchList/set_active_filters',
  SORT_CHANGE: 'searchList/sortChange',
  CLICK_INTERACTION: 'searchList/clickInteraction',
  IS_REDIRECT: 'searchList/redirect',
  RESET_REDIRECT: 'searchList/redirect_reset',
  CHANGE_FILTER_API_STATUS: 'searchList/filter_api_status',
  RESET_CLEAR_ALL: 'searchList/reset_clear_all',
  FETCH_EMPTY_STATE_PROGRESS: 'searchList/fetch_empty_state_progress',
  FETCH_EMPTY_STATE_SUCCESS: 'searchList/fetch_empty_state_success',
  FETCH_EMPTY_STATE_FAILED: 'searchList/fetch_empty_state_failed',
  FETCH_EMPTY_RANGE_ERROR: 'searchList/fetch_empty_range_error',
  IS_FILTER_OPEN: 'searchList/is_filter_open',
  CONV_SEARCH_FETCH_PROGRESS: 'searchList/conv_search_fetch_progress',
  CONV_SEARCH_FETCH_SUCCESS: 'searchList/conv_search_fetch_success',
  CONV_SEARCH_FETCH_ERROR: 'searchList/conv_search_fetch_error',
};

export default actionTypes;
